module.exports = __webpack_public_path__ + "static/media/benefit.9776ee43.png";